<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <div style="display: flex;justify-content: space-between">
          <div >
            <el-button
              v-access:add
              icon="el-icon-plus"
              @click="add"
              size="small"
              :disabled="isloading"
              type="danger"
              >新增</el-button
            >
          </div>
          <div style="display: flex">
            <el-input
              style="width: 290px;margin-right: 10px;"
              v-model="searchModel.searchKey"
              clearable
              :placeholder="placeholder"
            />
            <div><el-button size="small" icon="el-icon-search" type="danger" @click="search">查询</el-button></div>
          </div>
        </div>
      </div>

      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="listData"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
          <el-table-column
            prop="ProjectCode"
            label="项目编号"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="ProjectName"
            label="项目名称"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="TeamName"
            label="项目归属"
            width="140"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="TotalAmount"
            label="累积金额"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="TotalExpAmount"
            label="支出金额"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="RemainingAmount"
            label="剩余金额"
            align="left"
          ></el-table-column>

          <el-table-column
            prop="Status"
            label="状态"
            :formatter="formatterStatus"
            width="100"
            align="center"
          ></el-table-column>
          <!-- <el-table-column
            prop="IsHelp"
            label="是否求助项目"
            :formatter="IsHelp"
            width="120"
            align="center"
          ></el-table-column> -->
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:modify
                v-if="Edit(scope.row)"
                @click="innerEdit(scope.row)"
                type="text"
                size="mini"
                >编辑</el-button
              >
              <!-- <el-button
                v-access:modify
                v-if="!approve(scope.row)"
                @click="innerset(scope.row)"
                type="text"
                size="mini"
                >{{ isHelp(scope.row) }}</el-button
              > -->
              <el-button
                v-access:read
                v-if="!approve(scope.row)"
                @click="innerRead(scope.row)"
                type="text"
                size="mini"
                >详情</el-button
              >
              <el-button
                v-access:delete
                v-if="Del(scope.row)"
                @click="innerDel(scope.row)"
                type="text"
                size="mini"
                >删除</el-button
              >
              <el-button
                v-access:modify
                v-if="approve(scope.row)"
                @click="innerApprove(scope.row)"
                type="text"
                size="mini"
                >送审</el-button
              >
              <el-button
                v-access:modify
                v-if="release(scope.row)"
                @click="innerRelease(scope.row)"
                type="text"
                size="mini"
                >发布</el-button
              >
              <el-button
                v-access:modify
                v-if="cancel(scope.row)"
                @click="innerCancel(scope.row)"
                type="text"
                size="mini"
                >取消发布</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <ModuleEdit
      v-if="formVisible"
      :dataForm="formData"
      :isDisabled="isEdit"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleEdit>
    <ModuleQuery
      v-if="formDataQuery"
      :dataForm="formData"
      :isDisabled="isEdit"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleQuery>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import ModuleEdit from "@/modules/zjrc/pages/material/publicwelfare/edit";
import ModuleQuery from "@/modules/zjrc/pages/material/publicwelfare/query";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import { mapGetters } from "vuex";
import api from "@/modules/zjrc/api";

export default {
  name: "list",
  data() {
    return {
      isloading: false,
      listData: [],
      headerRow: "header-row",
      formVisible: false,
      formDataQuery: false,
      formTitle: "",
      formData: {},

      total: 0,
      currentPage: 1,
      pageSize: 15,

      //搜索字段
      searchModel: {
        status: "",
        searchKey: "",
      },
      placeholder: "项目编号 / 项目名称 / 捐赠归属",
      isEdit: false,

      StepId:"",

    };
  },
  methods: {
    //初始化数据
    loadData() {
      this.isloading = true;
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        status: this.searchModel.status,
        searchKey: this.searchModel.searchKey,
      };
      window.console.log(params)
      api.QueryPublicWelfare(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          var data = rep.data.Data.rows;
          this.listData = data;
        }
        this.isloading = false;
      });
    },
    //新增
    add() {
      this.isEdit = false;
      this.formTitle = "新增公益项目";
      this.formData = {IsDonation: true};
      api.QueryWelfareIndex().then((rep) => {
        if (rep.data.Code === 0) {
          let index = rep.data.Data;
          if (index < 10) {
            this.formData.ProjectCode = "ZJRC0" + index;
          } else {
            this.formData.ProjectCode = "ZJRC" + index;
          }
          this.formData.Creator = this.GetCurrentUserInfo.RealName;
          this.formData.CreatorId = this.GetCurrentUserInfo.Id;
          this.formVisible = true;
        }
      });
    },
    //编辑
    innerEdit(rowData) {
      this.isEdit = false;
      this.formTitle = "编辑公益项目";
      this.formData = Object.assign({}, rowData);
      this.formData.EndTime = rowData.EndTime * 1000;
      this.formVisible = true;
    },
    innerRead(rowData) {
      this.isEdit = true;
      this.formTitle = "查看详情";
      this.formData = Object.assign({}, rowData);
      this.formDataQuery = true;
    },
    formCallBack(data) {
      this.formVisible = false;
      this.formDataQuery = false;
      if (data != null) {
        this.loadData();
      }
    },
    //改变分页大小
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    //改变当前页码
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 280;
      }
      return tableMaxHeight;
    },
    //状态
    formatterStatus(item) {
      switch (item.Status) {
        case 0:
          return "草稿";
        case 1:
          return "已发布";
        case 2:
          return "审核中";
        case 3:
          return "已审核";
      }
    },
    IsHelp(rowData) {
      return rowData.IsHelp ? "是" : "否";
    },
    //搜索
    search(keyword) {
      this.currentPage = 1;
      this.loadData();
    },
    //重置
    reset() {
      this.searchModel = {
        status: "",
        searchKey: "",
      };
      this.currentPage = 1;
      this.loadData();
    },
    //送审
    innerApprove(rowData) {
      const vm = this
       vm.$confirm('确定送审选中公益项目?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(()=>{
                  vm.isloading = true;
                  let params=Object.assign({}, rowData);
                  params.ProcName = "公益项目审批";
                  params.Creator = this.GetCurrentUserInfo.RealName;
                  params.CreatorId = this.GetCurrentUserInfo.Id;
                  api.SavePublicWelfareReview(params).then((rep) => {
                    if (rep.data.Code == 0) {
                      this.loadData();
                    }
                  });
                })
      
    },
    //发布
    innerRelease(rowData) {
      this.$confirm("请确认是否发布选中的项目？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isloading = true;
        rowData.Status = 1;
        let params = Object.assign({}, rowData);
        api.UpdatePublicWelfareStatus(params).then((rep) => {
          if (rep.data.Code == 0) {
            this.loadData();
          }
        });
      });
    },
    //取消发布
    innerCancel(rowData) {
      this.$confirm("请确认是否取消发布选中的项目？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isloading = true;
        rowData.Status = 3;
        let params = Object.assign({}, rowData);
        api.UpdatePublicWelfareStatus(params).then((rep) => {
          if (rep.data.Code == 0) {
            this.loadData();
          }
        });
      });
    },
    //删除
    innerDel(rowData) {
      this.$confirm("请确认是否删除选中的数据？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        rowData.IsDeleted = 1;
        let params = Object.assign({}, rowData);
        api
          .DeletePublicWelfare(params)
          .then((rep) => {
            if (rep.data.Code === 0) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.currentPage = 1;
              this.loadData();
            } else {
              this.$message({
                message: rep.data.Message,
                type: "error",
              });
            }
          })
          .catch((e) => {
            this.$message({
              message: e.toString(),
              type: "error",
            });
          });
      });
    },
    innerset(rowData) {
      let warmStr = rowData.IsHelp
        ? "请确认是否取消为求助项目"
        : "请确认是否设置为求助项目";
      this.$confirm(warmStr, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        rowData.IsHelp = !rowData.IsHelp;
        let params = Object.assign({}, rowData);
        api
          .UpdatePublicWelfareIsHelp(params)
          .then((rep) => {
            if (rep.data.Code === 0) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              // this.currentPage = 1;
              this.loadData();
            } else {
              this.$message({
                message: rep.data.Message,
                type: "error",
              });
            }
          })
          .catch((e) => {
            this.$message({
              message: e.toString(),
              type: "error",
            });
          });
      });
    },
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModuleEdit,
    ModuleQuery
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
    approve() {
      return (rowData) => {
        return rowData.Status == 0 ? true : false;
      };
    },
    release() {
      return (rowData) => {
        return rowData.Status == 3 ? true : false;
      };
    },
    cancel() {
      return (rowData) => {
        return rowData.Status == 1 ? true : false;
      };
    },
    isHelp() {
      return (rowData) => {
        return rowData.IsHelp ? "禁用求助项目" : "启用求助项目";
      };
    },
    Del() {
      return (rowData) => {
        return rowData.Status == 0 || rowData.Status == 3 ? true : false;
      };
    },
    Edit() {
      return (rowData) => {
        return rowData.Status == 0 || rowData.Status == 3 ? true : false;
      };
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped>
.list-form {
  padding: 20px;
  /* border-right: solid 1px #efefef; */
  box-sizing: border-box;
  float: left;
  overflow: auto;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}
/* .el-date-editor >>> .el-input__inner {
  padding-left: 10px !important;
} */

.el-select >>> .el-input__inner {
  width: 3rem;
}

/* .el-date-editor >>> .el-input__inner {
  width: 60%;
} */
.el-row >>> .el-date-editor {
  width: 2.5rem !important;
}
</style>
